import { ChangeEvent, useRef, useState } from 'react'
import { useOnClickOutside } from 'usehooks-ts'

import { AngleDownIcon, AngleUpIcon } from '@/components/icons'
import { Li, P1 } from '@/components/typography'
import FormElement from '@/components/form'
import { CheckBoxInputField } from '@/components/input'
import { locationOptions } from '@/interfaces/events'
import Block from '@/layouts/block'

interface LocationFilterProps {
  locations: string[]
  handleChangeLocation: (e: ChangeEvent<HTMLInputElement>) => void
}

export default function LocationFilter({
  locations,
  handleChangeLocation,
}: LocationFilterProps) {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)

  const handleToggleMenu = () => {
    setIsOpen(!isOpen)
  }

  useOnClickOutside(ref, () => setIsOpen(false))

  return (
    <Block
      className="flex flex-col relative"
      ref={ref}
      testId="navItemLargeWithSubItems"
    >
      <button
        className="flex items-center hover:cursor-pointer"
        onClick={handleToggleMenu}
      >
        <Li className="pr-2">Locatie</Li>
        {isOpen ? <AngleUpIcon /> : <AngleDownIcon />}
      </button>
      {isOpen && (
        <Block className="flex flex-col align-middle justify-center gap-2 absolute z-50 top-6 left-0 bg-neutral-white p-4 rounded-[20px] w-[200px]">
          <FormElement
            submitForm={() => {}}
            initialValues={{ searchQuery: '' }}
          >
            {(locationOptions || []).map(
              ({ value = '', label = '' }, index) => {
                return (
                  <CheckBoxInputField
                    key={`${value}-${index}`}
                    onChange={handleChangeLocation}
                    name={label}
                    value={locations.includes(value)}
                    wrapperClassName="my-4"
                    fieldClassName="hover:cursor-pointer"
                  >
                    <P1>{label}</P1>
                  </CheckBoxInputField>
                )
              }
            )}
          </FormElement>
        </Block>
      )}
    </Block>
  )
}
